import React from 'react'
import './AsciiTable.scss'

class AsciiTable extends React.Component {
  getAsciiEncoding = () => {
    const asciiControlChars = [
      {
        decimal: 0,
        char: 'NUL',
        description: 'null character',
      },
      {
        decimal: 1,
        char: 'SOH',
        description: 'start of header',
      },
      {
        decimal: 2,
        char: 'STX',
        description: 'start of text',
      },
      {
        decimal: 3,
        char: 'ETX',
        description: 'end of text',
      },
      {
        decimal: 4,
        char: 'EOT',
        description: 'end of transmission',
      },
      {
        decimal: 5,
        char: 'ENQ',
        description: 'enquiry',
      },
      {
        decimal: 6,
        char: 'ACK',
        description: 'acknowledge',
      },
      {
        decimal: 7,
        char: 'BEL',
        description: 'bell (ring)',
      },
      {
        decimal: 8,
        char: 'BS',
        description: 'backspace',
      },
      {
        decimal: 9,
        char: 'HT',
        description: 'horizontal tab',
      },
      {
        decimal: 10,
        char: 'LF',
        description: 'line feed',
      },
      {
        decimal: 11,
        char: 'VT',
        description: 'vertical tab',
      },
      {
        decimal: 12,
        char: 'FF',
        description: 'form feed',
      },
      {
        decimal: 13,
        char: 'CR',
        description: 'carriage return',
      },
      {
        decimal: 14,
        char: 'SO',
        description: 'shift out',
      },
      {
        decimal: 15,
        char: 'SI',
        description: 'shift in',
      },
      {
        decimal: 16,
        char: 'DLE',
        description: 'data link escape',
      },
      {
        decimal: 17,
        char: 'DC1',
        description: 'device control 1',
      },
      {
        decimal: 18,
        char: 'DC2',
        description: 'device control 2',
      },
      {
        decimal: 19,
        char: 'DC3',
        description: 'device control 3',
      },
      {
        decimal: 20,
        char: 'DC4',
        description: 'device control 4',
      },
      {
        decimal: 21,
        char: 'NAK',
        description: 'negative acknowledge',
      },
      {
        decimal: 22,
        char: 'SYN',
        description: 'synchronize',
      },
      {
        decimal: 23,
        char: 'ETB',
        description: 'end transmission block',
      },
      {
        decimal: 24,
        char: 'CAN',
        description: 'cancel',
      },
      {
        decimal: 25,
        char: 'EM',
        description: 'end of medium',
      },
      {
        decimal: 26,
        char: 'SUB',
        description: 'substitute',
      },
      {
        decimal: 27,
        char: 'ESC',
        description: 'escape',
      },
      {
        decimal: 28,
        char: 'FS',
        description: 'file separator',
      },
      {
        decimal: 29,
        char: 'GS',
        description: 'group separator',
      },
      {
        decimal: 30,
        char: 'RS',
        description: 'record separator',
      },
      {
        decimal: 31,
        char: 'US',
        description: 'unit separator',
      },
      {
        decimal: 32,
        char: 'space',
      },
      {
        decimal: 127,
        char: 'DEL',
        description: 'delete (rubout)',
      },
    ]

    const asciiEncoding = []
    for (let i = 0; i < 33; i++) {
      const data = asciiControlChars[i]
      data['hex'] = Number(i)
        .toString(16)
        .toUpperCase()
        .padStart(2, '0')
      data['urlEncoding'] = '%' + data['hex']

      asciiEncoding.push(data)
    }

    for (let i = 33; i < 127; i++) {
      const data = {
        decimal: i,
        char: String.fromCharCode(i),
        hex: Number(i)
          .toString(16)
          .toUpperCase()
          .padStart(2, '0'),
      }
      data['urlEncoding'] = '%' + data['hex']

      asciiEncoding.push(data)
    }

    const data = asciiControlChars[asciiControlChars.length - 1]
    data['hex'] = Number(127)
      .toString(16)
      .toUpperCase()
      .padStart(2, '0')
    data['urlEncoding'] = '%' + data['hex']

    asciiEncoding.push(data)

    return asciiEncoding
  }

  render () {
    const asciiEncoding = this.getAsciiEncoding()

    return (
      <table className="ascii-table">
        <thead>
          <tr>
            <th>Decimal</th>
            <th>Character</th>
            <th>URL Encoded Value (UTF-8)</th>
          </tr>
        </thead>
        <tbody>
          {asciiEncoding.map(data => (
            <tr key={data['decimal']}>
              <td>{data['decimal']}</td>
              <td>
                <span className="char">{data['char']}</span>
                {data['description'] ? (
                  <span className="desc">({data['description']})</span>
                ) : null}
              </td>
              <td>{data['urlEncoding']}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

export default AsciiTable
